import anchorLink from "./modules/_anchorLink";
import { header } from "./modules/_header";
import tabChange from "./modules/_tabChange";
import details from "./pages/_details";
import home from "./pages/_home";
import support from "./pages/_support";

addEventListener('DOMContentLoaded', (): void => {
  // 共通処理
  header();
  tabChange();
  anchorLink();

  // 各ページ固有の処理
  if (document.querySelector('.p-home') !== null) home();
  if (document.querySelector('.p-support') !== null) support();
  if (document.querySelector('.wp-content') !== null) details();
});
